console.log("sale pg");
 //slidesPerView: 2,
    //       spaceBetween: 20,
    //       loop: true,
    //       pagination: {
    //         el: swiperEl.querySelector(".swiper-pagination"),
    //         clickable: true,
    //       },
    //       breakpoints: {
    //         600: { slidesPerView: 2 },
    //         750: { slidesPerView: 3 },
    //         1024: { slidesPerView: 4 },
    //         1200: { slidesPerView: 5 },
    //       },
    //       // autoplay: {
    //       //   delay: 2000,
    //       //   disableOnInteraction: true
    //       // },
    const isSalePage = window.location.pathname.includes('/pages/sale');
const swiperConfigs = [
  {
    class: ".swiper-one",
    config: {
      slidesPerView: 1,
      spaceBetween: 20,
      // loop: true,
          loop: false,              // MUST be false
    watchOverflow: true, 
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: '', // Will be assigned dynamically
        prevEl: '', // Will be assigned dynamically
      },
      breakpoints: {
         600: { slidesPerView: 2 },
            750: { slidesPerView: 3,
               slidesPerGroup: 2,
             },
            1024: { slidesPerView: 4 ,
               slidesPerGroup: 3,
            },
             1200: isSalePage
        ? { slidesPerView: 4, slidesPerGroup: 4 } //  SALE PAGE
        : { slidesPerView: 4, slidesPerGroup: 4 }, //  OTHER PAGES
      },
    },
  },
  {
    class: ".swiper-two",
    config: {
      slidesPerView: 3,
          slidesPerGroup: 2,
       spaceBetween: 16,
     loop: false,              // MUST be false
    watchOverflow: true,  
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: '', // Will be assigned dynamically
        prevEl: '', // Will be assigned dynamically
      },
      breakpoints: {
         600: { slidesPerView: 4 ,
            slidesPerGroup: 2,
         },
            750: { slidesPerView: 7 ,
                slidesPerGroup: 4,
            },
            1024: { slidesPerView: 10,
                slidesPerGroup: 6,
             },
            1200: { slidesPerView: 10,
                slidesPerGroup: 8,
               
             },
      },
    },
  },
  {
    class: ".swiper-three",
    config: {
      slidesPerView: 1,
      spaceBetween: 20,
      // loop: true,
          loop: false,              // MUST be false
    watchOverflow: true, 
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: '', // Will be assigned dynamically
        prevEl: '', // Will be assigned dynamically
      },
      breakpoints: {
         600: { slidesPerView: 2 },
            750: { slidesPerView: 3 ,
               slidesPerGroup: 2,
            },
            1024: { slidesPerView: 4,
               slidesPerGroup: 3,
             },
               1200: isSalePage
        ? { slidesPerView: 4, slidesPerGroup: 4 } // SALE PAGE
        : { slidesPerView: 4, slidesPerGroup: 4 }, // OTHER PAGES
      },
    },
  },
];




document.addEventListener("DOMContentLoaded", function () {
   if (window.Swiper) {
    swiperConfigs.forEach(({ class: className, config }) => {
      document.querySelectorAll(className).forEach((swiperEl) => {
        // 🔁 Deep clone to avoid mutation issues
        const configClone = JSON.parse(JSON.stringify(config));

        // Assign pagination dynamically
        if (configClone.pagination && !configClone.pagination.el) {
          const paginationEl = swiperEl.querySelector(".swiper-pagination");
          if (paginationEl) {
            configClone.pagination.el = paginationEl;
          }
        }

        // Assign navigation dynamically (if used)
        if (configClone.navigation) {
          configClone.navigation.nextEl = swiperEl.querySelector(".swiper-button-next");
          configClone.navigation.prevEl = swiperEl.querySelector(".swiper-button-prev");
        }

        // 🚀 Initialize Swiper
        new Swiper(swiperEl, configClone);
      });
    });
  }
  else {
    console.error("Swiper library not loaded!");
  }
  // functionality
  const icons = document.querySelectorAll(".icon-container");
  const labels = document.querySelectorAll(".gender-label");

  function activateTab(index) {
    const selectedTab = icons[index].getAttribute("data-tab");

    // 1) Update active class on icons + labels
    icons.forEach((i) => i.classList.remove("active"));
    labels.forEach((l) => l.classList.remove("active"));

    icons[index].classList.add("active");
    labels[index].classList.add("active");

    // 2) Show/hide all gender-index based blocks
    const genderBlocks = document.querySelectorAll("[data-gender-index]");
    genderBlocks.forEach(function (block) {
      if (block.getAttribute("data-gender-index") === selectedTab) {
        block.classList.remove("gender-hidden");
      } else {
        block.classList.add("gender-hidden");
      }
    });
  }

  // 🔹 Click on IMAGE
  icons.forEach(function (icon, index) {
    icon.addEventListener("click", function () {
      activateTab(index);
    });
  });

  // 🔹 Click on TEXT LABEL
  labels.forEach(function (label, index) {
    label.addEventListener("click", function () {
      activateTab(index);
    });
  });
  // // functionality
  // const icons = document.querySelectorAll(".icon-container");
  // const labels = document.querySelectorAll(".gender-label");
  

  // icons.forEach(function (icon ,index) {
  //   icon.addEventListener("click", function () {
  //     const selectedTab = this.getAttribute("data-tab");
  //     // 1
  //     // 1. Update active class
  //     icons.forEach((i) => i.classList.remove("active"));
  //     labels.forEach((i) => i.classList.remove("active"));
      
  //     labels[index].classList.add("active");
  //     this.classList.add("active");

  //     // 2
  //     const genderBlocks = document.querySelectorAll("[data-gender-index]");
  //     genderBlocks.forEach(function (block) {
  //       if (block.getAttribute("data-gender-index") === selectedTab) {
  //         block.classList.remove("gender-hidden");
  //       } else {
  //         block.classList.add("gender-hidden");
  //       }
  //     });
  //   });
  // });
  // functionality end

//   document.querySelectorAll('.brands-container').forEach(function(container) {
//       const sectionIndex = container.getAttribute('data-gender-index');
//       const pagination = document.querySelector(`.brands-pagination[data-gender-index="${sectionIndex}"]`);
// console.log(pagination , 'pagination')
//       if (pagination) {
//         new Ajaxinate({
//           container: `.brands-container[data-gender-index="${sectionIndex}"]`,
//           pagination: `.brands-pagination[data-gender-index="${sectionIndex}"]`,
//           loadingText: "Loading more...",
//           offset: 1000,
//           method: "scroll", // or "click"
//         });
//       }
//     });

  // var endlessScroll = new Ajaxinate({
  //   container: "#AjaxinateContainer",
  //   pagination: "#AjaxinatePagination",
  //   loadingText: "Loading more...",
  //   offset: 1000,
  //   method: "scroll",
  // });
  // console.log(endlessScroll);

  // dom loaded end
});
